/*************************************************************************
 *
 * 「ページの上部へ」ボタンの処理を行います。
 *
 *************************************************************************/
export default function() {
  $(function() {
    var btn = $(".goTop a");

    /*
     * スクロール位置によってボタンの表示や位置を操作します。
     */
    $(window).scroll(function() {
      var docSpH = $(document).height();
      var winSpH = window.innerHeight;
      var cpSpH  = $("#footer_copyright").height();
      var scrSpTop = $(document).scrollTop();
      var optSpLoc = docSpH - winSpH - cpSpH - 30;

      /*
       * 最下部へのスクロールの最後のタイミングでページに追随するようにします。
       */
      if (scrSpTop < optSpLoc) {
        btn.css("position", "fixed");
      } else {
        btn.css("position", "inherit");
      }

      /*
       * ページ上部では非表示とします。
       */
      if (scrSpTop < 600) btn.fadeOut(300);

      /*
       * ページ下部にスクロールした際に表示します。
       */
      if (scrSpTop > 1100) btn.fadeIn(300);
    }).scroll();

    /*
     * 押下時にページ上部にスクロールします。
     */
    btn.click(function() {
      $("body, html").animate({scrollTop: 0}, 500);
      return false;
    });
  });
}



// WEBPACK FOOTER //
// ./src/js/moc_footer_gotop.js